import React, { Component } from "react"
import AppCard from "./containers/AppCard"
import "./Index.scss"
import WelcomeContainer from "app/components/common/WelcomeContainer"

import { observer, inject } from "mobx-react"
import { setCurrentApp } from "../../api/localTools"

@inject("auth") @observer
export default class Index extends Component {
  componentDidMount() {
    const { auth } = this.props;
    (auth.needLoadApps ? auth.getApps() : Promise.resolve()).then(this.checkApps)
  }

  /**
   * 如果只有一个 APP 的话，直接跳入当前 App
   */
  checkApps = () => {
    const { auth, history } = this.props
    if (auth.apps.length === 1) {
      history.replace(`/jab/${auth.apps[0]}/entrance`)
      setCurrentApp(auth.apps[0])
    } else if (auth.userInfo.roleType === 'main') {
      history.replace(`/jab/main/preview/overview`)
      setCurrentApp('preview')
    } else if (auth.userInfo.roleType === 'research') {
      setCurrentApp('pgs')
      history.replace('/jab/main/research/pgs/overview')
    }
  }

  render() {
    return (
      <WelcomeContainer>
        <div className="apps-container">
          {this.props.auth.apps.map(app =>
            <AppCard key={app} app={app} {...this.props} />
          )}
        </div>
      </WelcomeContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/apps/index.js